module.exports = __webpack_public_path__ + "static/media/dawghawtdawg-macbook-game-1.f3b13b70.jpg";